export default "__VITE_ASSET__psPTkcD___"